import React, { useState } from 'react';
import InputField from '../../components/InputField';
import Button from '../../components/Button';
import { supabase } from '../../lib/supabase';

function SignInPage({ onNavigate }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const { error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setError(error.message);
    } else {
      onNavigate('home');
    }
    setLoading(false);
  }

  return (
    <div className="min-h-screen bg-surface-page flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <h1 className="text-h2 text-neutral-900 mb-2">Sign in</h1>
        <p className="text-body text-neutral-500 mb-8">
          New to Clean Shopper?{' '}
          <button
            type="button"
            onClick={() => onNavigate('signup')}
            className="text-primary-500 font-semibold hover:text-primary-400 transition-colors duration-fast focus:outline-none underline"
          >
            Create an account
          </button>
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          <InputField
            id="email"
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
          <InputField
            id="password"
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password"
            required
          />

          {error && (
            <p className="text-caption text-error">{error}</p>
          )}

          <Button type="submit" variant="primary" size="md" loading={loading} className="w-full">
            Sign in
          </Button>
        </form>
      </div>
    </div>
  );
}

export default SignInPage;
